import React from "react";
import styled from "@emotion/styled";
import { text, surface, zIndex, opacity, fontWeight, spacing } from "@atlas-int/tokens";
import { Button } from "@atlas-int/ui";

const ZoomButton = styled(Button)`
  width: 80px;
  min-height: 22px;
  background-color: ${surface.raised};
  color: ${text.primary};
  opacity: ${opacity.hover};
  margin-bottom: ${spacing[4]};
  font-weight: ${fontWeight.bold};
  text-transform: uppercase;
  pointer-events: auto;

  &:hover:not(:disabled) {
    opacity: 1;
    background-color: ${surface.muted};
  }
`;

const Container = styled.div<{
  $top?: string;
  $right?: string;
}>`
  position: absolute;
  top: ${({ $top }) => $top ?? spacing[4]};
  right: ${({ $right }) => $right ?? spacing[0]};
  width: 100px;
  z-index: ${zIndex.above};
`;

export interface ZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  /** Override the top position (CSS value) */
  top?: string;
  /** Override the right position (CSS value) */
  right?: string;
  className?: string;
}

const ZoomControls = React.memo<ZoomControlsProps>(
  ({ onZoomIn, onZoomOut, onReset, top, right, className }) => (
    <Container $top={top} $right={right} className={className} data-download-exclude>
      <ZoomButton
        variant="outline"
        size="xs"
        onClick={(e) => {
          e.stopPropagation();
          onZoomIn();
        }}
      >
        + ZOOM
      </ZoomButton>
      <ZoomButton
        variant="outline"
        size="xs"
        onClick={(e) => {
          e.stopPropagation();
          onZoomOut();
        }}
      >
        - ZOOM
      </ZoomButton>
      <ZoomButton
        variant="outline"
        size="xs"
        onClick={(e) => {
          e.stopPropagation();
          onReset();
        }}
      >
        RESET ZOOM
      </ZoomButton>
    </Container>
  ),
);

ZoomControls.displayName = "ZoomControls";

export default ZoomControls;
